import { render, staticRenderFns } from "./SsnUpdate.vue?vue&type=template&id=e8488acc"
import script from "./SsnUpdate.vue?vue&type=script&lang=js"
export * from "./SsnUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports